import styles from "./video-modal.module.less";
import { TActionObject } from "../../../types/modal-types";
import { useEffect, useRef, useState } from "react";
import ReactYoutubePlayer from "react-player/youtube";
import Modal from "../modal/modal";

type TVideoModalProps = {
  videoUrl?: string;
  youtubeVideoId?: string;
  isOpen?: boolean;
  portalContainer?: HTMLElement | null;
  close?: TActionObject;
  onEscapeKeyDown?: () => void;
};

export const VideoModal = ({
  isOpen = false,
  portalContainer,
  close,
  videoUrl,
  youtubeVideoId,
  onEscapeKeyDown,
}: TVideoModalProps) => {
  const videoElement = useRef<HTMLVideoElement>(null);
  const [videoProgression, setVideoProgression] = useState(0);

  //create a function that will make the video play when the modal is open and pause when the modal is closed
  useEffect(() => {
    if (videoElement.current) {
      if (!isOpen) {
        setVideoProgression(videoElement?.current?.currentTime);
      }
    }
  }, [isOpen]);

  const playVideo = () => {
    if (videoElement.current) {
      //video starts to play too fast for good UX if not delayed
      setTimeout(() => {
        videoElement?.current?.play();
      }, 300);
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      onEscapeKeyDown={onEscapeKeyDown}
      close={close}
      portalContainer={portalContainer}
      modalOverlayClassName={styles.modalOverlay}
    >
      <div className={styles.innerWrapper}>
        {(videoUrl || youtubeVideoId) && (
          <div className={styles.videoWrapper}>
            <div className={[styles.innerVideoWrapper, videoUrl ? styles.nativeVideo : ""].join(" ")}>
              {videoUrl && (
                <video
                  onCanPlay={playVideo}
                  ref={videoElement}
                  // with #t= you can set the time in seconds where the video should start (e.g. #t=10 will start the video at 10 seconds)
                  // https://developer.mozilla.org/en-US/docs/Web/Guide/Audio_and_video_delivery#specifying_playback_range
                  src={videoUrl + "#t=" + videoProgression}
                  preload={"auto"}
                  className={styles.video}
                  controls
                />
              )}
              {!videoUrl && youtubeVideoId && (
                <ReactYoutubePlayer
                  width={"100%"}
                  height={"100%"}
                  playing={true}
                  controls={true}
                  url={`https://www.youtube.com/watch?v=${youtubeVideoId}`}
                />
              )}
            </div>
          </div>
        )}
      </div>
    </Modal>
  );
};

export default VideoModal;
